import Image from 'next/image'
import React from 'react'
import LazyLoad from 'react-lazy-load'
import H2El from '../../Elements/H2El/H2El'
import ParagraphEl from '../../Elements/ParagraphEl/ParagraphEl'
import ReadMoreBtnEl from '../../Elements/ReadMoreBtnEl/ReadMoreBtnEl'
import cx from 'classnames'
import styles from './ImageRowEn.module.css'
import { sharedData } from '../../Data/sharedData'
import imgCsrMobile from '../../../images/img-row-mobile.jpg'
import imgCSR from '../../../images/imgCSR.jpg'
import Link from 'next/link'

const ImageRowEn = () => {
  return (
    <LazyLoad offset={200}>
      <div
        className={cx(
          styles.sliderContent,
          'w-100',
          'h-100',
          'position-relative'
        )}
      >
        <Image
          alt='CSR'
          src={imgCSR}
          className={cx(styles.mainImage, 'd-none', 'd-lg-flex')}
          width='100%'
          height='100%'
        />
        <Image
          width='100%'
          height='100%'
          alt='CSR'
          src={imgCsrMobile}
          className={cx(styles.mainImage, 'd-flex', 'd-lg-none')}
        />
        <div className={cx(styles.sliderOverlay, 'position-absolute')}></div>
        <div className={cx(styles.slidesInfo, 'position-absolute')}>
          <div className='w-100 d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-between p-3'>
            <div className='d-flex flex-column flex-xxl-row align-items-xxl-center align-items-start justify-content-center p-4'>
              <H2El extraClasses={[styles.titleMarginBottom]}>
                <span className='enFontFamily'>Social Responsibilities</span>
              </H2El>
              <span
                className={cx(styles.verticalLine, 'd-xxl-flex', 'd-none')}
              ></span>
              <ParagraphEl
                extraClasses={[
                  styles.paraMarginBottom,
                  'px-lg-5',
                  'px-xl-0',
                  'px-xxl-5'
                ]}
              >
                <span className='enFontFamily'>
                  Innovative Oportunities For Everyone; Ranging From Empowering
                  Native and Rural Businesses to Transparent and Purposeful
                  Donnations.
                </span>
              </ParagraphEl>
            </div>
            <div
              className='d-flex align-items-center justify-content-center'
              style={{ padding: '0px 30px' }}
            >
              {/* <ReadMoreBtnEl
                btnTitle="Read more"
                href={`https://about.digikala.com/digikalamehr/${sharedData.utmParams}`}
              /> */}
              <Link
                aria-label='read more'
                href={`https://about.digikala.com/digikalamehr/${sharedData.utmParamsEn}`}
                target='_blank'
                className={cx(
                  styles.readmoreBtnStylesReverce,
                  'd-flex',
                  'align-items-center',
                  'justify-content-center'
                )}
              >
                Read more
              </Link>
            </div>
          </div>
        </div>
      </div>
    </LazyLoad>
  )
}

export default ImageRowEn
